import { array, number, object } from 'yup';

export type ConstructionItemSetting = {
  id: number;
  companyMasterId: number;
  vendorCompanyId: number;
  constructionItemId: number;
  unitAmount: number | null;
};

export type ConstructionItemSettingEdit = Omit<
  ConstructionItemSetting,
  'companyMasterId' | 'vendorCompanyId' | 'id'
>;

export const validationSchemaConstructionItemSettingForm = object().shape({
  settings: array().of(
    object().shape({
      unitAmount: number()
        .transform((value: string) => (Number.isNaN(value) ? null : value))
        .nullable()
        .required('入力してください')
    })
  )
});
